import { render, staticRenderFns } from "./PopImagePreView.vue?vue&type=template&id=233a1f95&scoped=true&"
import script from "./PopImagePreView.vue?vue&type=script&lang=ts&"
export * from "./PopImagePreView.vue?vue&type=script&lang=ts&"
import style0 from "./PopImagePreView.vue?vue&type=style&index=0&id=233a1f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a1f95",
  null
  
)

export default component.exports